<template>
  <el-card id="secondary">
    <div class="main clearfloat marginT20">
      <div class="templateBox left">
        <img
          class="phoneImg"
          :src="require('@/assets/imges/standard/airCleaner/airSecond.png')"
          alt
        />
      </div>
      <!-- 箭头块 -->
      <div class="iconBox left">
        <i class="el-icon-right iconRight" style="margin-top: 66px"></i>
        <i class="el-icon-right iconRight" style="margin-top: 270px"> </i>
      </div>
      <!-- 配置块 -->
      <div class="configBox left">
        <!-- 页面配置 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="110px">
          <!-- 页面类型 -->
          <el-form-item label="页面类型" prop="type">
            <el-select class="btnConfigInput" size="small" v-model="form.type">
              <el-option
                v-for="item in pageTypes"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 导航栏名称 -->
          <el-form-item label="导航栏名称" prop="nvgName">
            <el-input
              size="small"
              class="btnConfigInput"
              v-model="form.nvgName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="nvgName">
            <div class="img-list">
              <div class="img-container">
                <p>背景图</p>
                <el-upload
                  ref="bgImg"
                  class="bgImg-uploader"
                  action="useless"
                  :show-file-list="false"
                  :limit="1"
                  accept=".png"
                  :http-request="handleChoseFile1"
                >
                  <img
                    v-if="displayImgUrl1"
                    :src="displayImgUrl1"
                    class="bgImg"
                  />
                  <i v-else class="el-icon-plus bgImg-uploader-icon"></i>
                </el-upload>
                <div style="color:red;">
                  支持扩展名：.PNG； 尺寸要求：750*750
                </div>
              </div>
              <div class="img-container">
                <p>背景图片（适用于全面屏）</p>
                <el-upload
                  ref="bgImg1"
                  class="bgImg-uploader"
                  action="useless"
                  :show-file-list="false"
                  :limit="1"
                  accept=".png"
                  :http-request="handleChoseFile2"
                >
                  <img
                    v-if="displayImgUrl2"
                    :src="displayImgUrl2"
                    class="bgImg"
                  />
                  <i v-else class="el-icon-plus bgImg-uploader-icon"></i>
                </el-upload>
                <div style="color:red;">
                  支持扩展名：.PNG； 尺寸要求：750*750
                </div>
              </div>
            </div>
          </el-form-item>
          <!-- 浮窗 -->
          <el-form-item label="浮窗" prop='secondImageId'>
            <el-select
              v-model="form.floatingWindow.secondImageId"
              size="small"
              class="btnConfigInput"
              @change="handleDialogChange"
            >
              <el-option
                v-for="page in pages"
                :key="page.id"
                :value="page.id"
                :label="handlePageName(page)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 按钮列表 -->
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ["propertes", "productId", "pageInfo", "pages"],
  data() {
    let validsecondImageId = (rule, value, callback) => {
      if (!this.form.floatingWindow.secondImageId) {
        callback(new Error('请选择浮窗'))
      } else {
        callback()
      }
    }
    return {
      dialogVision: false,
      form: {
        type: 21, // 页面类型
        nvgName: "", // 导航栏名称
        backgroundImage: "", // 背景图片
        backgroundImageFull: "", // 背景 全面屏
        floatingWindow: {
          secondImageId: '',
          pageType: '',
        },
      },
      pageTypes: [
        {
          value: 21,
          label: "配置"
        }
      ],
      rules: {
        type: [
          {
            required: true,
            message: "请选择页面类型",
            trigger: "blur"
          }
        ],
        nvgName: [
          {
            required: true,
            message: "请输入导航栏名称",
            trigger: "blur"
          }
        ],
        secondImageId: [
          {
            required: true,
            validator: validsecondImageId,
            trigger: "change"
          }
        ],
      }
    };
  },
  created() {
    if (this.pageInfo.id) {
      this.form = { ...this.pageInfo }
    }
  },
  computed: {
    displayImgUrl1() {
      return this.form.backgroundImage
        ? this.$store.state.standard.fileLoad + this.form.backgroundImage
        : "";
    },
    displayImgUrl2() {
      return this.form.backgroundImageFull
        ? this.$store.state.standard.fileLoad + this.form.backgroundImageFull
        : "";
    }
  },
  methods: {
    handleDialogChange(id) {
      let page = this.pages.filter((el) => el.id === id)[0]
      if (page) {
        this.form.floatingWindow.pageType = page.type
      }
    },
    checkForm() {
      let pass = false;
      this.$refs.form.validate(valid => {
        if (valid) {
          pass = valid;
        }
      });
      return pass;
    },
    // 提交表单
    handleSubmit: function() {
      if (!this.checkForm()) return;
      return {
        ...this.form
      };
    },
    // 上传图片
    handleChoseFile1(param) {
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.uploadFiles(formData).then(res => {
        if (res.data.success) {
          this.form.backgroundImage = res.data.data.toString();
          this.$refs.bgImg.clearFiles()
        }
      });
    },
    handleChoseFile2(param) {
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.uploadFiles(formData).then(res => {
        if (res.data.success) {
          this.form.backgroundImageFull = res.data.data.toString();
          this.$refs.bgImg1.clearFiles()
        }
      });
    },
    // 转译页面名称
    handlePageName: function(page) {
      let type = this.$utils.escapePageName(page.type),
        nvgName = page.nvgName;
      if (page.inner) {
        return type;
      } else {
        return nvgName + "-" + type;
      }
    }
  }
};
</script>

<style scoped>
.img-list {
  display: flex;
}
.img-container {
  margin-right: 48px;
}
.templateBox {
  width: 280px;
}
.iconRight {
  display: block;
  font-size: 28px;
}

.title {
  font-weight: 500;
  font-size: 14px;
}
.phoneImg {
  width: 280px;
  height: 500px;
}
.configBox {
  border: 1px solid #ccc;
  width: calc(100% - 350px);
  border-radius: 5px;
  padding: 20px;
  min-height: 478px;
}
.btnConfigHeader {
  max-height: 40px;
  vertical-align: bottom;
  font-size: 14px;
}
.btnConfigUpload {
  display: inline-block;
  vertical-align: bottom;
}
.btnConfigInput {
  width: 180px;
}
.btnConfigLong {
  width: calc(100% - 320px);
}
.btnImage {
  margin-left: 10px;
  vertical-align: bottom;
  width: 28px;
  height: 28px;
}
.longInput {
  width: 250px;
}
.checkItem {
  width: 200px;
}
</style>
